import { render, staticRenderFns } from "./RatingSelectionRadioButtons.vue?vue&type=template&id=70e05a22&scoped=true&"
import script from "./RatingSelectionRadioButtons.vue?vue&type=script&lang=js&"
export * from "./RatingSelectionRadioButtons.vue?vue&type=script&lang=js&"
import style0 from "./RatingSelectionRadioButtons.vue?vue&type=style&index=0&id=70e05a22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e05a22",
  null
  
)

export default component.exports